import { HoursMaskedInput } from "src/components/HoursMaskedExerciseAttributeInput";
import { useMaskedInputRegistryHandlers } from "src/workouts/exerciseAttributeInput.shared";
import { useWorkoutItemSetContext } from "src/workouts/WorkoutItemSetContext";

export function HoursExerciseAttribute() {
  const workoutItemSetContext = useWorkoutItemSetContext();
  const value = workoutItemSetContext.getEditableValue();
  const registryHandlers = useMaskedInputRegistryHandlers(
    workoutItemSetContext.getEditableInputId(),
    value,
  );

  return (
    <HoursMaskedInput
      key={registryHandlers.key}
      defaultValue={value}
      disabled={workoutItemSetContext.isEditableInputDisabled()}
      onAccept={(value) => {
        workoutItemSetContext.updateEditableValue(value);
      }}
      registryHandlers={registryHandlers}
    />
  );
}
